import { Prisma, prisma } from "client";

// READ
export const getBoothBuilderById = async (eventId: string) => {
  const boothBuilder = await prisma.boothBuilder.findFirst({
    where: {
      eventId,
    },
  });

  return boothBuilder;
};

// CREATE
export const upsertBoothBuilder = async (
  eventId: string,
  templateConfig: any
) => {
  // Check if the event exists
  const existingBoothBuilder = await prisma.boothBuilder.findUnique({
    where: {
      eventId,
    },
  });

  let boothBuilder = null;
  if (existingBoothBuilder) {
    boothBuilder = await prisma.boothBuilder.update({
      where: {
        eventId,
      },
      data: {
        templateConfig,
      },
    });
  } else {
    boothBuilder = await prisma.boothBuilder.create({
      data: {
        templateConfig,
        event: {
          connect: {
            id: eventId,
          },
        },
      },
    });
  }

  return boothBuilder;
};
